import { useMutation } from "@tanstack/react-query";
import { toastServerError } from "helpers";
import { ApiError, ApiServiceError } from "libs/api";
import { MutationOptions } from "libs/reactQuery";

import { requestCollectMoney } from "./collectMoney.request";

const useCollectMoney = (
  options?: MutationOptions<void, ApiServiceError<ApiError>>
) => {
  return useMutation({
    mutationFn: requestCollectMoney,
    onError: toastServerError,
    ...options
  });
};

export default useCollectMoney;
